import React, {
  useEffect,
  useState,
  useCallback
} from 'react'
import { useParams } from 'react-router'
import { Card, CardHeader, Row, Col, ListGroup, ListGroupItem } from 'reactstrap'
import { TitlePage } from 'components/atoms'
import { CardLoader } from 'components/organisms'
import CustomerRefundVouchersApiV2 from 'api/v2/admins/customer-refund-vouchers-api-v2'
import withLoader from 'hocs/with-loader'
import { ALERT_TYPES } from 'constants/alert-constants'
import VoucherDetailCard from 'domains/customer-refund-voucher/organisms/detail-card'
import CustomerRefundItemView from 'domains/customer-refund/molecules/item-view'
import PropTypes from 'prop-types'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const cannotUseOnMarketingDiscountProductsRule = {
  code     : 'is_marketing_discount',
  operator : '=',
  value    : false
}

const CustomerRefundVoucherDetailPage = ({ pageUtils }) => {
  const { id }                      = useParams()
  const [ voucher, setVoucher ]     = useState({})
  const [ isLoading, setIsLoading ] = useState(false)

  const handleFetchRefundVoucher = useCallback ((orderId) => {
    setIsLoading(true)
    CustomerRefundVouchersApiV2.show(orderId)
      .then((response) => {
        const data = response.data.refund_voucher
        setVoucher(data)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => setIsLoading(false))
  }, [ pageUtils ])

  useEffect(() => {
    handleFetchRefundVoucher(id)
  }, [ handleFetchRefundVoucher, id, pageUtils ])


  const handleClickGenerateVoucher = ({ cannotUseOnMarketingDiscountProducts }) => {
    let params = {}

    if (cannotUseOnMarketingDiscountProducts) {
      params = {
        orderId      : id,
        productRules : [ cannotUseOnMarketingDiscountProductsRule ]
      }
    }
    else {
      params = {
        orderId: id
      }
    }

    CustomerRefundVouchersApiV2.generateVoucher(params)
      .then(() => {
        pageUtils.setAlertMsg('Sucessfully generated voucher code!', ALERT_TYPES.SUCCESS)
        handleFetchRefundVoucher(id)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }

  const VoucherDetailCardWithLoader = withLoader(VoucherDetailCard, CardLoader)

  const CustomerRefundListGroup = () => (
    <ListGroup>
      {
        voucher.refunds && voucher.refunds.map((refund) => (
          <ListGroupItem key={ refund.id }>
            <CustomerRefundItemView refund={ refund } />
          </ListGroupItem>
        ))
      }
    </ListGroup>
  )

  return (
    <>
      <TitlePage mainTitle='Refund With Voucher Code' subTitle=''/>
      <Row>
        <Col md={ 5 }>
          <VoucherDetailCardWithLoader
            isLoading={ isLoading }
            voucher={ voucher }
            handleClickGenerateVoucher={ handleClickGenerateVoucher }
          />
        </Col>
        <Col md={ 7 }>
          <Card>
            <CardHeader>
              Items
            </CardHeader>
            <CustomerRefundListGroup />
          </Card>
        </Col>
      </Row>
    </>
  )
}

CustomerRefundVoucherDetailPage.propTypes    = propTypes
CustomerRefundVoucherDetailPage.defaultProps = defaultProps


export default CustomerRefundVoucherDetailPage
